import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DataService } from '../../data.service';

/**
 *  TANTÁRGYI FELMENTÉSEK – rögzítő felület
 *
 *  Eddig a felmentés csak a KRÉTÁ-ból ÉRKEZETT: a szinkron behúzta, a napló névsora
 *  mutatta, de rögzíteni nem lehetett. Ha az igazgató határozatot hozott, azt a KRÉTÁ-ban
 *  kellett felvinni, és megvárni a következő szinkront – addig a tanár nem tudott róla.
 *
 *  Itt a SAJÁT nyilvántartás van. Két lista:
 *    - „Saját rögzítés": amit mi vittünk fel; szerkeszthető, törölhető, és ha kérjük,
 *      visszaírásra vár a KRÉTA felé.
 *    - „KRÉTÁ-ból": a szinkron tükre. Csak olvasható – de egy gombbal ÁTVEHETŐ a saját
 *      nyilvántartásba, onnantól szerkeszthető.
 *
 *  AMI NEM CSAK NYILVÁNTARTÁS: az óralátogatás alóli felmentés kiszürkíti a tanuló sorát
 *  a naplóban (nem lehet hiányzónak beírni), és elveszi az órát a szülői/tanulói
 *  órarendből. Ezért kér a mentés határozott választ arra, mi alól mentesül.
 */
@Component({
  selector: 'app-admin-felmentes',
  templateUrl: './felmentes.component.html',
  styleUrls: ['./felmentes.component.scss'],
})
export class AdminFelmentesComponent implements OnInit {
  sajatIntezmeny: any;
  felhasznalo = '';

  osztalyok: any[] = [];
  tantargyak: any[] = [];
  tanulok: any[] = [];

  sajat: any[] = [];
  kreta: any[] = [];
  visszairasraVar = 0;

  szuroOsztaly = '';
  kereses = '';
  mind = false;

  toltodik = false;
  mentes = false;
  hiba = '';

  urlapNyitva = false;
  urlap: any = this.uresUrlap();
  szerkesztettId = '';

  /** A „mi menne ki a KRÉTÁ-ba" száraz futás eredménye. */
  kuldendo: any = null;

  constructor(private http: HttpClient, private data: DataService) {}

  private uresUrlap() {
    return {
      oktazon: '', tanulo_nev: '', tantargy: '', tantargy_nev: '',
      kezdete: '', vege: '', oralatogatas_aloli: false, ertekeles_aloli: false,
      szovegesen_ertekelheto: false, hosszabb_felkeszulesi_ido: false, irasbeli_helyett_szobeli: false,
      szobeli_helyett_irasbeli: false, ok: '', hatarozat: '', kretaba: false,
    };
  }

  async ngOnInit() {
    this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    const user = await this.data.getFromStorage('user');
    this.felhasznalo = String(user?.username || user?.adid || '');
    await Promise.all([this.torzsBetolt(), this.betolt()]);
  }

  private get int() { return String(this.sajatIntezmeny?.intezmenyId || '').replace(/^\/+|\/+$/g, ''); }
  private p(extra: Record<string, any> = {}) {
    const u = new URLSearchParams({ felhasznalo: this.felhasznalo });
    for (const [k, v] of Object.entries(extra)) if (v !== '' && v !== null && v !== undefined) u.set(k, String(v));
    return u.toString();
  }

  async torzsBetolt() {
    try {
      this.osztalyok = await firstValueFrom(this.http.get<any[]>(`/api/felmentes/osztalyok/${this.int}?${this.p()}`));
      this.tantargyak = await firstValueFrom(this.http.get<any[]>(`/api/felmentes/tantargyak/${this.int}?${this.p()}`));
    } catch { this.osztalyok = []; this.tantargyak = []; }
  }

  async betolt() {
    this.toltodik = true; this.hiba = '';
    try {
      const r: any = await firstValueFrom(this.http.get<any>(
        `/api/felmentes/lista/${this.int}?${this.p({ osztaly: this.szuroOsztaly, q: this.kereses, mind: this.mind ? 1 : '' })}`));
      this.sajat = r?.sajat || [];
      this.kreta = r?.kreta || [];
      this.visszairasraVar = Number(r?.visszairasra_var) || 0;
    } catch (e: any) {
      this.hiba = e?.error?.error || 'A lista betöltése nem sikerült.';
    }
    this.toltodik = false;
  }

  /** A tanulóválasztó az osztályhoz vagy a beírt névtöredékhez kér névsort. */
  async tanulokBetolt(keres = '') {
    try {
      this.tanulok = await firstValueFrom(this.http.get<any[]>(
        `/api/felmentes/tanulok/${this.int}?${this.p({ osztaly: this.szuroOsztaly, q: keres })}`));
    } catch { this.tanulok = []; }
  }

  ujFelmentes() {
    this.urlap = this.uresUrlap();
    this.szerkesztettId = '';
    this.urlapNyitva = true;
    this.tanulokBetolt();
  }

  szerkeszt(f: any) {
    this.urlap = {
      oktazon: f.oktazon, tanulo_nev: f.tanulo_nev, tantargy: f.tantargy || '', tantargy_nev: f.tantargy_nev || '',
      kezdete: f.kezdete || '', vege: f.vege || '',
      oralatogatas_aloli: !!f.oralatogatas_aloli, ertekeles_aloli: !!f.ertekeles_aloli,
      szovegesen_ertekelheto: !!f.szovegesen_ertekelheto,
      hosszabb_felkeszulesi_ido: !!f.hosszabb_felkeszulesi_ido,
      irasbeli_helyett_szobeli: !!f.irasbeli_helyett_szobeli,
      szobeli_helyett_irasbeli: !!f.szobeli_helyett_irasbeli,
      ok: f.ok || '', hatarozat: f.hatarozat || '', kretaba: f.kreta_allapot !== 'helyben',
    };
    this.szerkesztettId = f.id;
    this.urlapNyitva = true;
    this.tanulokBetolt();
  }

  /** A tantárgyválasztó a NEVET tölti: a felmentés arra szól (a KRÉTA is nevet ad). */
  tantargyValt() {
    const t = this.tantargyak.find((x) => String(x.id) === String(this.urlap.tantargy));
    this.urlap.tantargy_nev = t ? t.name : '';
  }

  tanuloValt() {
    const t = this.tanulok.find((x) => String(x.oktazon) === String(this.urlap.oktazon));
    this.urlap.tanulo_nev = t ? t.nev : '';
  }

  async ment() {
    this.mentes = true;
    try {
      const torzs = { ...this.urlap, felhasznalo: this.felhasznalo };
      if (this.szerkesztettId) {
        await firstValueFrom(this.http.put(`/api/felmentes/tetel/${this.szerkesztettId}`, torzs));
      } else {
        await firstValueFrom(this.http.post(`/api/felmentes/${this.int}`, torzs));
      }
      this.data.sendToast('Mentve.', 'success');
      this.urlapNyitva = false;
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
    }
    this.mentes = false;
  }

  async torol(f: any) {
    if (!confirm(`Biztosan törlöd? (${f.tanulo_nev} – ${f.tantargy_nev || 'minden tantárgy'})`)) return;
    try {
      await firstValueFrom(this.http.request('delete', `/api/felmentes/tetel/${f.id}`,
        { body: { felhasznalo: this.felhasznalo } }));
      this.data.sendToast('Törölve.', 'success');
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A törlés nem sikerült.', 'error');
    }
  }

  /** A KRÉTA-tükör sora átkerül a saját nyilvántartásba – onnantól szerkeszthető. */
  async atvesz(k: any) {
    try {
      const r: any = await firstValueFrom(this.http.post(`/api/felmentes/kretabol/${this.int}`,
        { kreta_idk: [k.kreta_id], felhasznalo: this.felhasznalo }));
      if (r?.kihagyva?.length) {
        this.data.sendToast(`Nem vehető át: ${r.kihagyva[0].ok}`, 'warning');
      } else {
        this.data.sendToast('Átvéve – innentől nálunk szerkeszthető.', 'success');
      }
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az átvétel nem sikerült.', 'error');
    }
  }

  async mindetAtvesz() {
    const idk = this.kreta.map((k) => k.kreta_id);
    if (!idk.length) return;
    try {
      const r: any = await firstValueFrom(this.http.post(`/api/felmentes/kretabol/${this.int}`,
        { kreta_idk: idk, felhasznalo: this.felhasznalo }));
      this.data.sendToast(`${r?.atvett || 0} felmentés átvéve`
        + (r?.kihagyva?.length ? `, ${r.kihagyva.length} kihagyva (párosítatlan tanuló).` : '.'),
      r?.kihagyva?.length ? 'warning' : 'success');
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az átvétel nem sikerült.', 'error');
    }
  }

  /** „Mi menne ki": a küldendő adat, küldés nélkül. */
  async miMenneKi() {
    try {
      this.kuldendo = await firstValueFrom(this.http.get<any>(
        `/api/felmentes/visszairandok/${this.int}?${this.p()}`));
      if (!this.kuldendo?.tetelek?.length) this.data.sendToast('Nincs visszaírásra váró felmentés.', 'info');
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A lekérés nem sikerült.', 'error');
    }
  }

  /*  A VISSZAÍRÁS KÉT LÉPÉSBEN. Előbb a próbafutás: belép a KRÉTÁ-ba, megkeresi a
   *  tanulót és a tantárgyat, összeállítja a küldendő adatot – de nem küld. Ez mondja
   *  meg, hogy a párosítás rendben van-e, mielőtt bármi kimenne. */
  kuldesFut = false;
  kuldesEredmeny: any = null;

  async probafutas() { await this.kuldes({ probafutas: 1 }); }

  async visszairas(mulasztasokatAtir = false) {
    if (!mulasztasokatAtir && !confirm(
      `${this.visszairasraVar} felmentés kerül ki a KRÉTÁ-ba. Folytatod?`)) return;
    await this.kuldes(mulasztasokatAtir ? { mulasztasokat_atir: 1 } : {});
  }

  private async kuldes(extra: any) {
    this.kuldesFut = true;
    this.kuldesEredmeny = null;
    try {
      this.kuldesEredmeny = await firstValueFrom(this.http.post<any>(
        `/api/felmentes/visszairas/${this.int}`, { ...extra, felhasznalo: this.felhasznalo }));
      const e = this.kuldesEredmeny;
      if (e?.probafutas || extra.probafutas) {
        this.data.sendToast(`Próbafutás kész – ${e?.tetelek?.length || 0} tétel állt össze.`, 'success');
      } else {
        this.data.sendToast(
          `Elküldve: ${e?.elkuldve || 0}; hiba: ${e?.hiba || 0}; kihagyva: ${e?.kihagyva || 0}.`,
          (e?.hiba || e?.kihagyva) ? 'warning' : 'success');
      }
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A visszaírás nem sikerült.', 'error');
    }
    this.kuldesFut = false;
  }

  /*  A KRÉTA akkor kérdez vissza, ha az időszakra már van rögzített mulasztás: a mentés
   *  átírná őket. Ezt nem csináljuk meg magától – itt jelenik meg a lehetőség. */
  get mulasztasKerdes(): boolean {
    return (this.kuldesEredmeny?.tetelek || []).some((t: any) => /mulaszt/i.test(t?.uzenet || ''));
  }

  /*  Próbafutásnál nem írunk ki „Elküldve: 0"-t: semmit nem küldtünk, tehát a nulla
   *  nem eredmény, hanem félrevezetés. */
  get probafutasVolt(): boolean {
    return (this.kuldesEredmeny?.tetelek || []).some((t: any) => t?.probafutas);
  }

  /** Emberi szöveg arra, mi alól mentesül – ugyanaz a szóhasználat, mint a naplóban. */
  mentessegSzoveg(f: any): string {
    const mi = [f.oralatogatas_aloli ? 'óralátogatás' : '', f.ertekeles_aloli ? 'értékelés' : '']
      .filter(Boolean).join(' és ');
    const kedv = [
      f.hosszabb_felkeszulesi_ido ? 'hosszabb felkészülési idő' : '',
      f.irasbeli_helyett_szobeli ? 'írásbeli helyett szóbeli' : '',
      f.szobeli_helyett_irasbeli ? 'szóbeli helyett írásbeli' : '',
    ].filter(Boolean).join(', ');
    const kedvSzoveg = kedv ? `kedvezmény: ${kedv}` : '';
    if (!mi) {
      return [f.szovegesen_ertekelheto ? 'szövegesen értékelhető' : '', kedvSzoveg].filter(Boolean).join('; ')
        || 'kedvezmény (nincs mentesség megjelölve)';
    }
    return `${mi} alól${f.szovegesen_ertekelheto ? ', szövegesen értékelhető' : ''}${kedvSzoveg ? `; ${kedvSzoveg}` : ''}`;
  }

  allapotSzoveg(f: any): string {
    return ({
      helyben: 'csak nálunk', visszairasra_var: 'visszaírásra vár', elkuldve: 'KRÉTÁ-ban is', hiba: 'hiba',
    } as any)[f.kreta_allapot] || f.kreta_allapot;
  }
}
